import { render, staticRenderFns } from "./AsistenciasView.vue?vue&type=template&id=4b20d70f&scoped=true&"
import script from "./AsistenciasView.vue?vue&type=script&lang=js&"
export * from "./AsistenciasView.vue?vue&type=script&lang=js&"
import style0 from "./AsistenciasView.vue?vue&type=style&index=0&id=4b20d70f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b20d70f",
  null
  
)

export default component.exports